const initialState = {
    Emplss: [],
  };
  export default function (state = initialState, action) {
    switch (action.type) {
      case "NOMEEmpl_SELECT":
        return {
          ...state,
          Emplss: action.payload,
        };
      default:
        return state;
    }
  }
  